import React from 'react';
import { Icon } from './Icon.js';
export const IconBracketsCurly = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M17 3H20V6.6459C20 8.70151 21.1614 10.5807 23 11.5V12.5C21.1614 13.4193 20 15.2985 20 17.3541V21H17", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M7 3H4V6.6459C4 8.70151 2.8386 10.5807 1 11.5V12.5C2.8386 13.4193 4 15.2985 4 17.3541V21H7", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconBracketsCurly.js.map